export default {
  getPromotion: (state) => {
    if (!state.promotionParticipation?.active) {
      return null;
    }

    return state.promotionParticipation?.promotion;
  },

  getPromotionAmount: (state) => {
    return state.promotionParticipation?.promotion?.amount;
  },
  getPromotionInvited: (state) => {
    return state.promotionParticipation?.invited;
  },

  getPaymentMethods: (state) => {
    return state.paymentMethods;
  },

  getSelectedCardId: (state) => {
    return state.selectedCardId;
  },
};
